import { useFormikContext } from "formik";
// import { Button } from "./ui/button";

import { Input } from "./ui/input";
import CustomLabelText from "./CustomLabelText";
import { Label } from "./ui/label";
import { NumericFormat } from "react-number-format";
import { MaxLimit } from "../lib/Misc";
import { cn } from "../lib/utils";
import { Button } from "./ui/button";
import { Plus, Trash2 } from "lucide-react";

export default function BeneficaryRow({ index, values, errors, push, remove }) {
  const { setFieldValue } = useFormikContext();

  return (
    <div className="border rounded-xl p-3 space-y-2">
      {/* Header */}
      <div className="flex items-start justify-between">
        <h4 className="p-0 m-0 font-bold">Beneficiary - {index + 1}</h4>
        <div className="flex gap-2 justify-end">
          {index + 1 === values?.beneficiaries?.length ? (
            <>
              <Button
                type="button"
                className="h-fit w-fit p-1 "
                onClick={() => {
                  push({
                    first_name: "",
                    last_name: "",
                    percentage: "",
                  });
                }}
              >
                <Plus size={20} />
              </Button>{" "}
              {!values?.beneficiaries?.[index]?.is_used && (
                <>
                  <Button
                    type="button"
                    className="h-fit w-fit p-1 bg-red-500"
                    onClick={() => remove(index)}
                  >
                    <Trash2 size={20} />
                  </Button>
                </>
              )}
            </>
          ) : (
            !values?.beneficiaries?.[index]?.is_used && (
              <>
                <Button
                  type="button"
                  className="h-fit w-fit p-1 bg-red-500"
                  onClick={() => remove(index)}
                >
                  <Trash2 size={20} />
                </Button>
              </>
            )
          )}
        </div>
      </div>
      <div className="grid md:grid-cols-3 gap-4">
        <div className="grid gap-2">
          <Label htmlFor={`beneficiaries.${index}.first_name`}>
            <CustomLabelText
              required={false}
              labelText="First Name"
              errorField={errors?.beneficiaries?.[index]?.first_name}
            />
          </Label>
          <Input
            id={`beneficiaries.${index}.first_name`}
            type="text"
            name={`beneficiaries.${index}.first_name`}
            value={
              values?.beneficiaries?.[index]?.first_name
                ? values?.beneficiaries?.[index]?.first_name
                : ""
            }
            onChange={(e) => {
              setFieldValue(
                `beneficiaries.${index}.first_name`,
                e?.target?.value,
              );
            }}
            autoComplete="off"
            onKeyPress={(e) => {
              e.which === 13 && e.preventDefault();
            }}
            className={
              errors?.beneficiaries?.[index]?.first_name &&
              `focus-visible:ring-red-500 border-red-500`
            }
          />
        </div>
        <div className="grid gap-2">
          <Label htmlFor={`beneficiaries.${index}.last_name`}>
            <CustomLabelText
              required={false}
              labelText="Last Name"
              errorField={errors?.beneficiaries?.[index]?.last_name}
            />
          </Label>
          <Input
            id={`beneficiaries.${index}.last_name`}
            type="text"
            name={`beneficiaries.${index}.last_name`}
            value={
              values?.beneficiaries?.[index]?.last_name
                ? values?.beneficiaries?.[index]?.last_name
                : ""
            }
            onChange={(e) => {
              setFieldValue(
                `beneficiaries.${index}.last_name`,
                e?.target?.value,
              );
            }}
            autoComplete="off"
            onKeyPress={(e) => {
              e.which === 13 && e.preventDefault();
            }}
            className={
              errors?.beneficiaries?.[index]?.last_name &&
              `focus-visible:ring-red-500 border-red-500`
            }
          />
        </div>

        <div className="grid gap-2">
          <Label htmlFor={`beneficiaries.${index}.percentage`}>
            <CustomLabelText
              required={false}
              labelText="Percentage (%)"
              errorField={errors?.beneficiaries?.[index]?.percentage}
            />
          </Label>

          <NumericFormat
            type="text"
            name={`beneficiaries.${index}.percentage`}
            value={values?.beneficiaries?.[index]?.percentage}
            onChange={(e) => {
              setFieldValue(
                `beneficiaries.${index}.percentage`,
                e?.target?.value,
              );
            }}
            onBlur={(e) => {
              setFieldValue(
                `beneficiaries.${index}.percentage`,
                e?.target?.value,
              );
            }}
            decimalScale={2}
            allowNegative={false}
            thousandSeparator={true}
            suffix="%"
            isAllowed={(values) => MaxLimit(values)}
            autoComplete="off"
            onKeyPress={(e) => {
              e.which === 13 && e.preventDefault();
            }}
            className={
              errors?.beneficiaries?.[index]?.percentage
                ? `${cn(
                    "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                  )} focus-visible:ring-red-500 border-red-500`
                : cn(
                    "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                  )
            }
          />
        </div>
      </div>
    </div>
  );
}
